import React, { useEffect, useState, useLayoutEffect, useImperativeHandle, useContext } from "react";
import { Container, Col, Row, Button, Tab, Tabs, Table, Accordion } from "react-bootstrap";
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import URLstateContext from "../../../provider/CommonContext";
import { format, parseISO } from 'date-fns';
import { Vortex } from 'react-loader-spinner';

function IpoReturns() {
  const [data, getData] = useState("")
  const [chartData, setchartData] = useState([]);
  const [valueLi, setchartperiod] = useState('1M');
  const [valuebtn, setValueBtn] = useState("bse");
  const { BaseURL } = useContext(URLstateContext);
  const [loadingshow, setloadingshow] = useState(false);
  let getchartData, indicator;

  useEffect(() => {
    setloadingshow(true);
    const getUrl = BaseURL + "returnipo";
    fetch(`${getUrl}/${valuebtn}/${valueLi}/-/-`)
      .then((response) => response.json())
      .then((datachart) => {
        getchartData = datachart.data;
        setchartData(getchartData);
        getData(datachart.data)

        setloadingshow(false);
        // console.log(getchartData, "getchartData")
      })
      .catch((error) => {
      });
  }, [valuebtn, valueLi]);


  useLayoutEffect(() => {
    // Create root element
    // https://www.amcharts.com/docs/v5/getting-started/#Root_element
    var root = am5.Root.new("chartdiv");


    // Set themes
    // https://www.amcharts.com/docs/v5/concepts/themes/
    root.setThemes([
      am5themes_Animated.new(root)
    ]);


    // Create chart
    // https://www.amcharts.com/docs/v5/charts/xy-chart/
    var chart = root.container.children.push(am5xy.XYChart.new(root, {
      panX: true,
      panY: true,
      wheelX: "panX",
      wheelY: "zoomX",
      pinchZoomX: true
    }));

    // Add cursor
    // https://www.amcharts.com/docs/v5/charts/xy-chart/cursor/
    var cursor = chart.set("cursor", am5xy.XYCursor.new(root, {}));
    cursor.lineY.set("visible", false);


    // Create axes
    // https://www.amcharts.com/docs/v5/charts/xy-chart/axes/
    var xRenderer = am5xy.AxisRendererX.new(root, { minGridDistance: 30 });
    xRenderer.labels.template.setAll({
      rotation: -40,
      centerY: am5.p50,
      centerX: am5.p100,
      paddingRight: 0,
      fontSize: 1.0
    });

    var xAxis = chart.xAxes.push(am5xy.CategoryAxis.new(root, {
      maxDeviation: 0.3,
      categoryField: "country",
      renderer: xRenderer,
      tooltip: am5.Tooltip.new(root, {})
    }));

    var yAxis = chart.yAxes.push(am5xy.ValueAxis.new(root, {
      maxDeviation: 0.3,
      renderer: am5xy.AxisRendererY.new(root, {})
    }));


    // Create series
    // https://www.amcharts.com/docs/v5/charts/xy-chart/series/
    var series = chart.series.push(am5xy.ColumnSeries.new(root, {
      name: "Series 1",
      xAxis: xAxis,
      yAxis: yAxis,
      valueYField: "value",
      sequencedInterpolation: true,
      stroke: am5.color(0x69CA44),
      categoryXField: "country",
      tooltip: am5.Tooltip.new(root, {
        labelText: "{valueY}"
      })
    }));


    series.set("fill", am5.color(0x69CA44));
    // series.set("fill", am5.color(0xff0000));

    yAxis.get("renderer").labels.template.setAll({
      fontSize: 12,

    });

    // Set data
    function generateChartData() {
      let chartData = [];
      if (data != null && data != []) {
        for (var i = 0; i < data.length; i++) {
          //   let newDate = new Date(data[i].yrc);

          chartData.push({
            country: data[i].CO_NAME,
            value: data[i].PerChange,
          });
        }
      }
      return chartData;
    }

    let datanew = generateChartData();

    xAxis.data.setAll(datanew);
    series.data.setAll(datanew);


    // Make stuff animate on load
    // https://www.amcharts.com/docs/v5/concepts/animations/
    series.appear(1000);
    chart.appear(1000, 100);


    return (() => {
      root.dispose();
    })
  }, [data])

  return (
    <>

      <div className='market-inner-common common-graph ipo-head'>
        <div className='market-header'>
          <h4>IPO Returns</h4>
        </div>
        <Container className="add-border table-box">
          <Row>
            <Col md={12}>
              <div className="divChartDrop">
                <div className='latest-date'>
                  {(data != null) ? <>
                    <p>
                      <span>{(data[0] != null) ? format(parseISO(data[0].LastTr_Date), 'dd-MMM-yyyy') : ''}</span> | &nbsp;
                      <span>{(data[0] != null && data[0].LastTr_Date.split("T")[1] !== "00:00:00") ? data[0].LastTr_Date.split("T")[1] : 'EOD'}</span></p></> : ''}
                </div>
                <div className="mainDivIpo">
                  <div className='ipo-return-toggle'>
                    <button value="nse" className={(valuebtn === "nse") ? "active" : ''} onClick={(event) => { setValueBtn(event.target.value) }}>NSE</button>
                    <button value="bse" className={(valuebtn === "bse") ? "active" : ''} onClick={(event) => { setValueBtn(event.target.value) }}>BSE</button>
                  </div>
                  <div class="ipo-dates">
                    <ul>
                      <li data-value="1M" className={(valueLi === "1M") ? "active" : ''} onClick={(event) => { setchartperiod(event.target.getAttribute("data-value")) }}>1M</li>
                      <li data-value="3M" className={(valueLi === "3M") ? "active" : ''} onClick={(event) => { setchartperiod(event.target.getAttribute("data-value")) }}>3M</li>
                      <li data-value="6M" className={(valueLi === "6M") ? "active" : ''} onClick={(event) => { setchartperiod(event.target.getAttribute("data-value")) }}>6M</li>
                      <li data-value="1Y" className={(valueLi === "1Y") ? "active" : ''} onClick={(event) => { setchartperiod(event.target.getAttribute("data-value")) }}>1Y</li>
                      <li data-value="3Y" className={(valueLi === "3Y") ? "active" : ''} onClick={(event) => { setchartperiod(event.target.getAttribute("data-value")) }}>3Y</li>
                    </ul>
                  </div>
                </div>
                {(chartData === null) ? <div className="errorDiv"><h4 className="errormsgIpo">No Chart Data Available !!!</h4></div> : ''}
              </div>
              <div id="chartdiv" style={{ width: "100%", height: "325px" }}></div>
              {loadingshow ? <div className="textcentervertex">
                <Vortex
                  visible={true}
                  height="80"
                  width="80"
                  ariaLabel="vortex-loading"
                  wrapperStyle={{}}
                  wrapperClass="vortex-wrapper"
                  colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                />
                <div className="model_popup">Please Wait...</div>
              </div> : ""
              }

            </Col>
          </Row>
        </Container>



      </div>

    </>
  )
}

export default IpoReturns
